import { useId } from 'react';

import PropTypes from 'prop-types';

import ErrorState from '@zenbusiness/zui/ErrorState';

import { ErrorBoundary } from '#client/components/ErrorBoundary';
import { HomeSection } from '#client/components/Section';

import { WidgetLink } from '../WidgetLink';

const toSnakeCase = (str) => str.toLowerCase().replace(/\s/g, '_');

function Widget({
  boundaryId = 'src/Widgets/Widget',
  content: WidgetContent,
  description,
  id: customId,
  moreLinkUrl,
  title,
  ...props
}) {
  const uniqueId = useId();
  const widgetId = customId || uniqueId;

  const eventProps = {
    appSection: 'home',
    elementValue: `${toSnakeCase(title)}_widget`,
  };

  return (
    <HomeSection
      title={title}
      slots={{
        aside: moreLinkUrl && <WidgetLink url={moreLinkUrl} text="See all" eventProps={eventProps} />,
      }}
    >
      <ErrorBoundary fallback={ErrorState} id={boundaryId}>
        <WidgetContent widgetId={widgetId} {...props} />
      </ErrorBoundary>
    </HomeSection>
  );
}

Widget.propTypes = {
  /** `id` for the ErrorBoundary */
  boundaryId: PropTypes.string,
  /** Widget content to display */
  content: PropTypes.oneOfType([PropTypes.func, PropTypes.elementType]).isRequired,
  /** Widget description to display */
  description: PropTypes.string,
  /** Unique ID to use for the widget */
  id: PropTypes.string,
  /** URL to link to when the "See all" link is clicked */
  moreLinkUrl: PropTypes.string,
  /** Widget title to display */
  title: PropTypes.string.isRequired,
};

export default Widget;
